export const GAME_LIST = 'GAME_LIST'